import React from "react";
import { ButtonBase, Paper, Typography } from '@material-ui/core'
import useStyles from "./StackCard.styles";


type stackTypes = {
  description: string,
  title: string,
  icon: string,
}

function StackCard({
  title,
  description,
  icon
}: stackTypes){
  const classes = useStyles();
  return(
    <Paper elevation={4} className={classes.cardWrapper}>
    <ButtonBase>
      <img src={icon} alt='' className={classes.iconImg} />
    </ButtonBase>
    <Typography className={classes.stackTitle}>{title}</Typography>
    <p>
      {description}
    </p>
    </Paper>
  )
}
export default StackCard;
